import React, { useEffect } from 'react';
import { element } from 'prop-types';
import { PracticeProviderContextProvider } from '../context/PracticeProviderContext';
import { useLocalStorage } from '@rehooks/local-storage';
import { useQuery } from 'react-query';
import { useExternalContact } from '../hooks/useExternalContacts';
import { chrApi } from '../api/api';

function PracticeProviderProvider(props) {
  const { isExternalContact } = useExternalContact();
  const [practice, setPractice] = useLocalStorage('__practiceId__');
  const [provider, setProvider] = useLocalStorage('__providerId__');
  const [token, setToken] = useLocalStorage('__token__');
  const [type, setType] = useLocalStorage('__type__');
  const [isML, setIsML] = useLocalStorage('__isML__');

  // TODO: Refactor use query to auto fetch on practice change
  const { data: practiceObj, refetch: refetchPractice } = useQuery('fetchPractice', () => chrApi('get', `practice/${practice}`, null, null).then((res) => res.data), {
    enabled: !!practice && !!token && !isExternalContact && !!type && type !== 'KuraMDMrr',
  });
  const { data: providerObj, refetch: refetchProvider } = useQuery('fetchProvider', () => chrApi('get', `user/profile`, null, null).then((res) => res.data), {
    enabled: !!provider && !!token && !isExternalContact && !!type && type !== 'KuraMDMrr',
    onSuccess: (response) => {
      setIsML(response?.isML);
    },
  });

  useEffect(() => {
    if (practice && token && type && type === 'Provider') {
      refetchPractice();
    }
  }, [practice]);

  return (
    <PracticeProviderContextProvider
      value={{
        practice,
        provider,
        setPractice,
        setProvider,
        practiceObj,
        providerObj,
        token,
        setToken,
        type,
        setType,
        isML,
        refetchPractice,
        refetchProvider,
      }}
    >
      {props.children}
    </PracticeProviderContextProvider>
  );
}

PracticeProviderProvider.propTypes = {
  children: element,
};

export default PracticeProviderProvider;
